import { useEffect, useState } from 'react';
import { useRouter } from 'next/router';
import Link from 'next/link';

const Custom404 = () => {
    const router = useRouter();
    const [countdown, setCountdown] = useState(2);

    useEffect(() => {
        const interval = setInterval(() => {
            setCountdown((prev) => {
                if (prev <= 1) {
                    router.push('/');
                    return 0;
                }
                return prev - 1;
            });
        }, 1000);

        return () => clearInterval(interval);
    }, [router]);

    return (
        <div style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            minHeight: '100vh',
            textAlign: 'center',
            padding: '20px'
        }}>
            <h1 style={{ fontSize: '3rem', marginBottom: '1rem' }}>404</h1>
            <h2 style={{ fontSize: '1.5rem', marginBottom: '1rem' }}>Page Not Found</h2>
            {/* <p style={{ marginBottom: '1rem', color: '#666' }}>
                The page you're looking for doesn't exist.
            </p> */}
            <p style={{ marginBottom: '2rem', color: '#666' }}>
                Redirecting to homepage in <strong>{countdown}</strong> second{countdown !== 1 ? 's' : ''}...
            </p>
            <Link href="/" style={{
                padding: '12px 24px',
                backgroundColor: '#0070f3',
                color: 'white',
                textDecoration: 'none',
                borderRadius: '5px',
                fontSize: '1rem'
            }}>
                Go back home now
            </Link>
        </div>
    );
};

export default Custom404; 